import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import * as Api from "./api";
//Will remove api in time and use rtk code gen

export interface PriceListCompanyModel
{
    period: "Month" | "Year";
    priceListCount?: number;
    priceListMax?: number;
    company: Api.FirmModel;
}

export const priceListApi = createApi({
    reducerPath: "priceListApi",
    baseQuery: fetchBaseQuery({ 
        baseUrl: '/',
        prepareHeaders: (headers, api) => {
            return headers;
        },
    }),
    endpoints: (build) => ({
        listPriceListByPeriod: build.query<PriceListCompanyModel, { period: "Month" | "Year" }>({
            query: (queryArg) => ({
                url: `/api/PriceList/ListPriceListByPeriod`,
                params: {
                    period: queryArg.period
                },
                prepareHeaders: headers => {
                    return headers
                }
            })
        }),
    }),
});

export const { useListPriceListByPeriodQuery } = priceListApi;